// default app vars

let g_dev = false;
let g_windowHeight = $(window).height();
let g_windowWidth = $(window).width();
let g_scroll = $(window).scrollTop();

// custom vars
let scrollMargin = 20;
let scrollTreshold = 25;

$(window).on('scroll', function () {
    g_scroll = $(window).scrollTop();
});

// On windows.resize
$(window).on('resize', function () {
    // Set window height/width on resize
    g_windowHeight = $(window).height();
    g_windowWidth = $(window).width();
});

if(typeof(document.querySelector('.overview-vacancies__intro')) != 'undefined' && document.querySelector('.overview-vacancies__intro') != null) {
    var overviewIntroHeight = document.querySelector('.overview-vacancies__intro').offsetHeight;
    var overviewVacancyHeight = document.querySelector('.vacancy-item__image').offsetHeight;

    overviewIntroScript();

    window.addEventListener('resize', function(event) {
        overviewIntroScript();
    });

    function overviewIntroScript() {
        overviewIntroHeight = document.querySelector('.overview-vacancies__intro').offsetHeight;
        overviewVacancyHeight = document.querySelector('.vacancy-item__image').offsetHeight;

        /* console.log(overviewIntroHeight + overviewVacancyHeight); */
        document.querySelector('.overview-vacancies__bg').style.height = (overviewIntroHeight + overviewVacancyHeight - 10 + 'px');
    }
}
